var SetOrUnset;
(function (SetOrUnset) {
    SetOrUnset["SET"] = "set";
    SetOrUnset["UNSET"] = "unset";
})(SetOrUnset || (SetOrUnset = {}));
/**
 * Must match supply names in `variables/supplies`
 *
 * TODO: Should this be moved to types?
 */
var SupplyItemType;
(function (SupplyItemType) {
    SupplyItemType["AMBER_BAG"] = "Amber Bag";
    SupplyItemType["CARESEND_BAG"] = "CareSend Bag";
    SupplyItemType["CONTAINER"] = "container";
    SupplyItemType["INSULATED_BAG"] = "Insulated Bag (Including ice pack)";
    SupplyItemType["MAIL_IN_BOX"] = "Mail-in box";
    SupplyItemType["PROCEDURE_BAG"] = "Procedure Bag";
    SupplyItemType["SPECIMEN_BAG"] = "Specimen Bag";
    SupplyItemType["TUBE"] = "tube";
})(SupplyItemType || (SupplyItemType = {}));

export { SetOrUnset, SupplyItemType };
